import React from 'react';
import classNames from 'classnames';

import { NamedLink } from '../../components';
import { createSlug } from '../../util/urlHelpers';
import { isBookingProcessAlias, isPurchaseProcessAlias } from '../../transactions/transaction';

import css from './RentBuyToggle.module.css';

const labelForListing = listing => {
  const transactionProcessAlias = listing?.attributes?.publicData?.transactionProcessAlias || '';
  if (isBookingProcessAlias(transactionProcessAlias)) {
    return 'Rent';
  }
  if (isPurchaseProcessAlias(transactionProcessAlias)) {
    return 'Buy';
  }
  return null;
};

/**
 * Shows a "Rent / Buy" toggle on the listing page when the current listing is
 * linked to a counterpart listing via the `pairedListingId` custom field.
 * Renders nothing if there's no paired listing, or if the pairing doesn't
 * resolve to one Rent option and one Buy option.
 */
const RentBuyToggle = props => {
  const { currentListing, pairedListing } = props;

  if (!pairedListing?.id) {
    return null;
  }

  const currentLabel = labelForListing(currentListing);
  const pairedLabel = labelForListing(pairedListing);

  if (!currentLabel || !pairedLabel || currentLabel === pairedLabel) {
    return null;
  }

  const pairedTitle = pairedListing.attributes?.title || '';

  return (
    <div className={css.root} role="group" aria-label="Choose rent or buy">
      <span className={classNames(css.option, css.optionActive)}>{currentLabel}</span>
      <NamedLink
        className={css.option}
        name="ListingPage"
        params={{ id: pairedListing.id.uuid, slug: createSlug(pairedTitle) }}
      >
        {pairedLabel}
      </NamedLink>
    </div>
  );
};

export default RentBuyToggle;
